import React, { useContext } from "react";
import "./RecentEntries.css";
import FormContext from "../../../context/FormContext";
import RecentEntriesTable from "../../operator_home/recent/RecentEntriesTable";
import ClaimTable from "../../claim/claim_table/ClaimTable";

const RecentEntries = ({
  claimFilter, setClaimFilter
}) => {
  const { filterEntry } = useContext(FormContext);

  return (
    <div className="operator-entries-container">
      {filterEntry ?
        <ClaimTable
          claimRecord={claimFilter}
          setClaimRecord={setClaimFilter}
        /> :
        <RecentEntriesTable />
      }
    </div>
  );
};

export default RecentEntries;
